import React from 'react'
import { useTranslation } from 'react-i18next';

interface IProps {
  detailsData: {
    key: string;
    value: string;
  }[];
}

const DetailsGrid: React.FC<IProps> = ({ detailsData }) => {
    const { t } = useTranslation();
  return (
    <div className="ticket-details__grid">
    {detailsData.map((detail) => (
      <div key={detail.key} className="ticket-details__item">
        <span className="body-text-small text-color-light-gray">{t(detail.key)}</span>
        <b className="body-text-small text-color-dark">{detail.value}</b>
      </div>
    ))}
  </div>
  )
}

export default DetailsGrid